import { useEffect, useState } from 'react'
import Spinner from 'app/components/Spinner'
import { gqlFetchOne } from 'app/lib/graphqlClient'
import { bg } from 'lib/background'
import { run } from 'lib/run'

let fetching: Record<string, Promise<string>> = {}
let cache: Record<string, string> = {}

export async function getRoleName(roleId: string) {
  if (cache[roleId] != null) return cache[roleId]
  if (fetching[roleId] != null) return fetching[roleId]
  if (!roleId || roleId === `undefined`) return

  return (fetching[roleId] = run(async () => {
    const role = await gqlFetchOne<{ name?: string }>(`role`, roleId, `id name`)
    return (cache[roleId] = role?.name || `Unknown Role`)
  }))
}

export function LazyRoleCell({
  roleId,
  className,
  loadingIndicator = true,
}: {
  roleId: string
  className?: string
  loadingIndicator?: boolean
}) {
  const [name, setName] = useState<string>(cache[roleId])

  useEffect(() => {
    if (name && cache[roleId] === name) return
    else setName(``)
    if (!roleId || roleId === `undefined`) {
      setName(`-`)
      return
    }
    bg(
      getRoleName(roleId).then((name) => {
        if (name != null) setName(name)
      }),
    )
  }, [roleId])

  return name ? <span className={className}>{name}</span> : loadingIndicator ? <Spinner size={5} /> : null
}
